import { observeBanner } from "../bannertracking";
import { hookLazyLoading } from "../lazyload";
import { hookDefaultGATracking } from "../ga-tracking";

export function onBannerElementInserted(element: HTMLAnchorElement) {
  hookLazyLoading(element.parentElement!);
  hookDefaultGATracking(element.parentElement!);
  if (element.dataset.id) {
    observeBanner(element);
  }
}
